import * as React from "react";
import { useTranslation } from "react-i18next";

import { Box, Tooltip } from "@mui/material";

import { COLORS } from "./constants";
import scanHelpImage from "./assets/scan-help.png";

// The "?" affordance next to the Scan Code field. On hover it shows the sample
// lottery ticket that tells the user which barcode to scan.
const ScanHelpTooltip: React.FC = () => {
  const { t } = useTranslation("translation");

  return (
    <Tooltip
      arrow
      placement='right'
      componentsProps={{
        tooltip: {
          sx: { backgroundColor: "#fff", boxShadow: 3, p: 1, maxWidth: "none" },
        },
        arrow: { sx: { color: "#fff" } },
      }}
      title={
        <Box>
          <img
            src={scanHelpImage}
            alt={t("scanHelpAlt", "Scan the bottom barcode on the ticket")}
            style={{ width: 360, height: 360, display: "block" }}
          />
        </Box>
      }
    >
      <Box
        component='span'
        aria-label={t("scanHelpAria", "Scan code help")}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 24,
          height: 24,
          borderRadius: "50%",
          border: `1px solid ${COLORS.grey}`,
          color: COLORS.grey,
          fontWeight: 600,
          fontSize: "15px",
          cursor: "help",
          userSelect: "none",
        }}
      >
        ?
      </Box>
    </Tooltip>
  );
};

export default ScanHelpTooltip;
